import {
  BenefitAggregationFragment,
  CareerLevelAggregationFragment,
  CityAggregationFragment,
  CountryAggregationFragment,
  DisciplineAggregationFragment,
  EmploymentTypeAggregationFragment,
  IndustryAggregationFragment,
  RemoteOptionAggregationFragment,
} from '@/graphql/generated';

type NonChangingNames =
  | 'remoteOption'
  | 'employmentType'
  | 'careerLevel'
  | 'discipline'
  | 'industry'
  | 'country'
  | 'city';

type MaybeAggregation<T> = Array<null | T> | null;
export type Aggregations = {
  remoteOptions?: MaybeAggregation<RemoteOptionAggregationFragment>;
  employmentTypes?: MaybeAggregation<EmploymentTypeAggregationFragment>;
  careerLevels?: MaybeAggregation<CareerLevelAggregationFragment>;
  disciplines?: MaybeAggregation<DisciplineAggregationFragment>;
  industries?: MaybeAggregation<IndustryAggregationFragment>;
  benefitsEmployeePerk?: MaybeAggregation<BenefitAggregationFragment>;
  benefitsWorkingCulture?: MaybeAggregation<BenefitAggregationFragment>;
  countries?: MaybeAggregation<CountryAggregationFragment>;
  cities?: MaybeAggregation<CityAggregationFragment>;
};

export type FilterResult = {
  options?:
    | MaybeAggregation<RemoteOptionAggregationFragment>
    | MaybeAggregation<EmploymentTypeAggregationFragment>
    | MaybeAggregation<CareerLevelAggregationFragment>
    | MaybeAggregation<DisciplineAggregationFragment>
    | MaybeAggregation<IndustryAggregationFragment>
    | MaybeAggregation<BenefitAggregationFragment>
    | MaybeAggregation<CountryAggregationFragment>
    | MaybeAggregation<CityAggregationFragment>;
  titleKey: string;
  paramName: NonChangingNames | 'benefit';
  propertyName: NonChangingNames | 'benefitEmployeePerk' | 'benefitWorkingCulture';
};

export const getFiltersFromAggregations = ({
  remoteOptions,
  employmentTypes,
  careerLevels,
  disciplines,
  industries,
  benefitsEmployeePerk,
  benefitsWorkingCulture,
  countries,
  cities,
}: Aggregations): Array<string | FilterResult> => {
  return [
    {
      options: remoteOptions,
      titleKey: 'SE_FILTER_JOBS_REMOTE_LABEL',
      paramName: 'remoteOption',
      propertyName: 'remoteOption',
    },
    {
      options: employmentTypes,
      titleKey: 'SE_FILTER_JOBS_TYPE_LABEL',
      paramName: 'employmentType',
      propertyName: 'employmentType',
    },
    {
      options: careerLevels,
      titleKey: 'SE_FILTER_JOBS_LEVEL_LABEL',
      paramName: 'careerLevel',
      propertyName: 'careerLevel',
    },
    {
      options: benefitsWorkingCulture,
      titleKey: 'JOBS_SEARCH_FILTER_WORKING_ATMOSPHERE',
      paramName: 'benefit',
      propertyName: 'benefitWorkingCulture',
    },
    {
      options: disciplines,
      titleKey: 'SE_FILTER_JOBS_DISCIPLINE_LABEL',
      paramName: 'discipline',
      propertyName: 'discipline',
    },
    { options: industries, titleKey: 'SE_FILTER_JOBS_INDUSTRY_LABEL', paramName: 'industry', propertyName: 'industry' },
    'salary',
    {
      options: benefitsEmployeePerk,
      titleKey: 'JOBS_SEARCH_FILTER_EMPLOYEE_PERKS',
      paramName: 'benefit',
      propertyName: 'benefitEmployeePerk',
    },
    { options: countries, titleKey: 'SE_FILTER_JOBS_COUNTRY_LABEL', paramName: 'country', propertyName: 'country' },
    { options: cities, titleKey: 'SE_FILTER_JOBS_CITY_LABEL', paramName: 'city', propertyName: 'city' },
    'projobs',
  ];
};
